export interface ShellLink {
  description: string
  label: string
  to: string
}

export const publicShellLinks: ShellLink[] = [
  {
    label: "Report",
    to: "/report",
    description: "Report a traffic incident with photos and location.",
  },
  {
    label: "Register",
    to: "/register",
    description: "Register your SafetyQR device.",
  },
  {
    label: "My Device",
    to: "/my-device",
    description: "Manage your registered devices.",
  },
]

export const operatorShellLinks: ShellLink[] = [
  {
    label: "Authority",
    to: "/authority",
    description: "View and manage incidents in your jurisdiction.",
  },
  {
    label: "Fleet",
    to: "/fleet",
    description: "Fleet analytics and vehicle management.",
  },
  {
    label: "Admin",
    to: "/admin",
    description: "System administration and organization management.",
  },
  {
    label: "Ops",
    to: "/ops",
    description: "Operations monitoring and integrations.",
  },
  {
    label: "Exports",
    to: "/exports",
    description: "Export reports and operational data.",
  },
]
